/* tslint:disable */
import {
  TutorialStep
} from '../index';

declare var Object: any;
export interface TutorialInterface {
  "objectTypeId": number;
  "objectId": number;
  "name": string;
  "displayName"?: string;
  "active"?: boolean;
  "data": any;
  "languageCode"?: any;
  "type"?: string;
  "createdAt"?: Date;
  "createdBy"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: number;
  "id"?: number;
  steps?: TutorialStep[];
}

export class Tutorial implements TutorialInterface {
  "objectTypeId": number;
  "objectId": number;
  "name": string;
  "displayName": string;
  "active": boolean;
  "data": any;
  "languageCode": any;
  "type": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  steps: TutorialStep[];
  constructor(data?: TutorialInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tutorial`.
   */
  public static getModelName() {
    return "Tutorial";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tutorial for dynamic purposes.
  **/
  public static factory(data: TutorialInterface): Tutorial{
    return new Tutorial(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tutorial',
      plural: 'Tutorials',
      path: 'Tutorials',
      idName: 'id',
      properties: {
        "objectTypeId": {
          name: 'objectTypeId',
          type: 'number'
        },
        "objectId": {
          name: 'objectId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "languageCode": {
          name: 'languageCode',
          type: 'any'
        },
        "type": {
          name: 'type',
          type: 'string',
          default: 'PLAYER'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        steps: {
          name: 'steps',
          type: 'TutorialStep[]',
          model: 'TutorialStep',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'tutorialId'
        },
      }
    }
  }
}
